'use strict';
var basepath = require('./basepath');

function loadJSON(file, callback) {

	var xobj = new XMLHttpRequest();
	xobj.open('GET', file, true); 
	xobj.onreadystatechange = function() {
		if (xobj.readyState === 4 && xobj.status === 200) {
			var json = JSON.parse(xobj.responseText);

			callback(json);
		}
	};
	xobj.send(null);
}


var api = {
	load: function(file, callback) {

		file = basepath.getPath(file);
		loadJSON(file, callback);
	}
};


module.exports = api;